import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SelectionOptionsComponent } from './selection-options.component';

const routes: Routes = [
  {
    path: '',
    component: SelectionOptionsComponent
  },
  {
    path: ':id',
    component: SelectionOptionsComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SelectionOptionsRoutingModule { }
